module.exports = __webpack_public_path__ + "media/images/bindingAccount/icon_apple-1b6668ff558a9ad4343c70729479574c.svg";